import Button from '@/components/public/ui/Button';

interface FormActionsProps {
  submitLabel: string;
  submittingLabel?: string;
  processing?: boolean;
  /** Extra disable condition for the submit (e.g. `!isFormValid`). */
  disabled?: boolean;
  /** Reset handler — renders the "Limpar" action when provided. */
  onReset?: () => void;
  resetLabel?: string;
  submittingHint?: string;
}

// Canonical form footer: a divider, a secondary reset action on the left and
// the primary submit on the right (full-width stacked on mobile, submit first).
// Use at the end of every form. See design-system.md §4.4.
export default function FormActions({
  submitLabel,
  submittingLabel = 'A enviar…',
  processing = false,
  disabled = false,
  onReset,
  resetLabel = 'Limpar',
  submittingHint,
}: FormActionsProps) {
  return (
    <div className="border-line mt-2 flex flex-col-reverse gap-3 border-t pt-6 sm:flex-row sm:items-center sm:justify-between">
      {processing && submittingHint ? (
        <span
          className="text-on-surface-light inline-flex items-center gap-2 text-sm"
          aria-live="polite"
        >
          <span
            className="border-primary/20 border-t-primary h-4 w-4 animate-spin rounded-full border-2"
            aria-hidden="true"
          />
          {submittingHint}
        </span>
      ) : onReset ? (
        <Button type="button" variant="ghost" onClick={onReset} disabled={processing}>
          {resetLabel}
        </Button>
      ) : (
        <span aria-hidden="true" />
      )}
      <Button
        type="submit"
        variant="primary"
        iconAfter="arrow_forward"
        disabled={processing || disabled}
        loading={processing}
      >
        {processing ? submittingLabel : submitLabel}
      </Button>
    </div>
  );
}
